import { CLOSE_THIRD_PARTY_DEMO_EXIT_CONFIRMATION } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageCloseThirdPartyDemoExitConfirmation(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: CLOSE_THIRD_PARTY_DEMO_EXIT_CONFIRMATION,
      data
    });
  }
}